import { render, staticRenderFns } from "./InterrelationsStep.vue?vue&type=template&id=ebb9ad10&"
import script from "./InterrelationsStep.vue?vue&type=script&lang=js&"
export * from "./InterrelationsStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports